import React, { useState, useEffect } from 'react';
import ActividadEditor from './ActividadEditor';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  setPending,
  deleted,
  setDeletedPending,
  getAllDeleted,
  restore,
  getAllByParent,
} from '../redux/actions/actividadActions';

import { setPending as setPendingProduccion } from '../redux/actions/produccionActions';

import { get as getParent } from '../redux/actions/campanaActions';

import { callStatus } from '../utils/constants';
import { Button, Space, Menu, Dropdown, Row, Col, Layout, Modal } from 'antd';
import { withRouter } from 'react-router-dom';

import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  UnorderedListOutlined,
  FormatPainterFilled,
  SelectOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import RestorePopup from './RestorePopup';
import BaseBox from './base/BaseBox';
import MetaTable from './base/MetaTable';
import dayjs from 'dayjs';
import moment from 'moment';
import { convertDate } from '../utils/funtions';
import ProduccionEditor from './ProduccionEditor';
import CustomCellRender from './base/CustomCellRender';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;

const MenuButton = styled(Button)`
  width: 100%;
  text-align: left;
`;

const ActividadList = ({
  location,
  stateData,
  establecimiento,
  cultivo,
  dispatch,
  match: {
    params: { id },
  },
  parent,
}) => {
  const [view, setView] = useState(1);
  const [showRestore, setShowRestore] = useState(false);
  const [showProduccion, setShowProduccion] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  const history = useHistory();

  const [dataSource, setDataSource] = useState([]);

  const formatDisplay = 'DD/MM/YYYY';

  useEffect(() => {
    dispatch(getAllByParent(id));
    dispatch(getParent(id));
    dispatch(setPending());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (stateData.list.status === callStatus.LIST_SUCCESS) {
      const data = [
        ...stateData.list.data.map((item) => {
          return {
            ...item,
            fecha: dayjs(
              new Date(moment(moment(convertDate(item.fecha)))).toISOString()
            ).format(formatDisplay),
          };
        }),
      ];

      setDataSource(data);
    }

    // eslint-disable-next-line
  }, [stateData]);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleRestore = () => {
    setShowRestore(true);
    getAllDeleted(dispatch);
  };

  const handleRestoreCancel = () => {
    setShowRestore(false);
    dispatch(setDeletedPending());
  };

  const handleRestoreOk = (data) => {
    dispatch(restore({ data: data }));
    setShowRestore(false);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleResumen = (data) => {
    history.push(`/campanas/actividades/${id}/resumen/${data.id}`);
  };
  const handleOrdenesTrabajo = (data) => {
    history.push(`/campanas/actividades/${id}/ordenes-trabajo/${data.id}`);
  };
  const handleGastos = (data) => {
    history.push(`/campanas/actividades/${id}/gastos/${data.id}`);
  };
  const handleRetiro = (data) => {
    history.push(`/campanas/actividades/${id}/produccion-retiros/${data.id}`);
  };
  const handleProduccion = (data) => {
    setShowProduccion(true);
    setRowEdit(data);
  };
  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };
  const handleHideProduccionEditor = () => {
    setShowProduccion(false);
    dispatch(setPendingProduccion());
    setRowEdit(null);
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const restoreColumns = [
    {
      ellipsis: true,
      title: 'Establecimiento',
      dataIndex: 'establecimiento_nombre',
    },
    {
      ellipsis: true,
      title: 'Cultivo',
      dataIndex: 'cultivo_nombre',
    },
  ];

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 60,
      ellipsis: true,
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
    },

    {
      width: 200,
      ellipsis: true,
      title: 'Establecimiento',
      dataIndex: 'establecimiento_nombre',
      sorter: (a, b) =>
        a.establecimiento_nombre.localeCompare(b.establecimiento_nombre),

      search: true,
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Cultivo',
      dataIndex: 'cultivo_nombre',
      onFilter: (value, record) => {
        return record.cultivo_id === value;
      },
      sorter: (a, b) => a.cultivo_nombre.localeCompare(b.cultivo_nombre),
      filterMultiple: true,
      filters: cultivo.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },

    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <Button onClick={(e) => handleResumen(record)}>Resumen</Button>
          <Button onClick={(e) => handleOrdenesTrabajo(record)}>
            Ordenes Trabajo
          </Button>
          <Button onClick={(e) => handleGastos(record)}>Gastos</Button>
          <Button onClick={(e) => handleRetiro(record)}>Retiros</Button>
          <Button onClick={(e) => handleProduccion(record)}>Producción</Button>
        </Space>
      ),
      width: 600,
    },
  ];

  const grid = { xs: 24, sm: 12, md: 12, lg: 8, xl: 8 };

  const menuView = (
    <Menu>
      <Menu.Item key="1">
        <MenuButton onClick={() => setView(1)} icon={<UnorderedListOutlined />}>
          Tabla
        </MenuButton>
      </Menu.Item>
      <Menu.Item key="2">
        <MenuButton onClick={() => setView(2)} icon={<UnorderedListOutlined />}>
          Box
        </MenuButton>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ height: '100%' }}>
      <Header
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          marginTop: '5px',
        }}
      >
        {parent.object.status === callStatus.OBJECT_SUCCESS && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <div
              style={{
                height: '17px',
              }}
            >
              <b>Campaña: </b>
              {parent.object.data.nombre}
            </div>
          </div>
        )}
      </Header>
      <Content>
        {view === 1 ? (
          <MetaTable
            dataSource={dataSource}
            dataColumns={columns}
            bordered={false}
            selection={false}
            loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
          />
        ) : (
          <Row gutter={8}>
            {stateData.list.data.map((item) => {
              return (
                <Col {...grid} key={item.id} style={{ marginBottom: '10px' }}>
                  <BaseBox
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    item={item}
                    title={item.establecimiento_nombre}
                    subtitle={item.cultivo_nombre}
                    moreInfo={item.campana}
                  />
                </Col>
              );
            })}
          </Row>
        )}
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar
            </Button>
            <Button
              type="primary"
              icon={<SelectOutlined />}
              size="small"
              style={{ marginLeft: '3px' }}
              onClick={(e) => handleRestore()}
            >
              Recuperar
            </Button>

            <Dropdown overlay={menuView}>
              <Button
                type="primary"
                icon={<FormatPainterFilled />}
                size="small"
                style={{ marginLeft: '3px' }}
              >
                Vista
              </Button>
            </Dropdown>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <ActividadEditor
          id={rowEdit.id}
          parentId={id}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}

      {showProduccion && rowEdit ? (
        <ProduccionEditor
          id={null}
          parentId={rowEdit.id}
          onCancel={handleHideProduccionEditor}
          visible={true}
        />
      ) : (
        false
      )}

      {showRestore &&
      stateData.deleted.status === callStatus.LIST_DELETED_SUCCESS ? (
        <RestorePopup
          columns={restoreColumns}
          data={stateData.deleted.data}
          onCancel={handleRestoreCancel}
          onOk={handleRestoreOk}
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { actividad, establecimiento, cultivo, campana } = state;
  const stateData = actividad;
  const parent = campana;
  return {
    stateData,
    establecimiento,
    cultivo,
    parent,
  };
};
export default connect(mapStateToProps)(withRouter(ActividadList));
